<template>
    <client-page>
        <v-container>
            <div class="tit-wrap text-center">
                <h2 class="tit tit--xl">회원가입시 약관 및 개인정보취급방침</h2>
            </div>

            <terms-component code="privacy" />
        </v-container>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import TermsComponent from "@/components/client/terms/terms-component.vue";

export default {
    components: {
        ClientPage,
        TermsComponent,
    },
};
</script>

<style scoped>
#app{
    background-color: var(--v-primary-lighten5) !important;
}
</style>
